import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getData(search: any, page: any, take: any): AxiosPromise {
  let url = "v1/users-suppliers?take=" + take + "&skip=" + page;
  if (search !== "") {
    url = url + "&search=" + search;
  }

  return api.get(url, {});
}

export function getSuppliers(): AxiosPromise {
  let url = "v1/suppliers";

  return api.get(url, {});
}

export function getDataById(id: number): AxiosPromise {
  return api.get("v1/users-suppliers/" + id, {});
}

export function postData(obj: any): AxiosPromise {
  return api.post("v1/users-suppliers", obj, {});
}

export function putData(obj: any, id: any): AxiosPromise {
  return api.put("v1/users-suppliers/" + id, obj, {});
}

export function deleteData(id: number): AxiosPromise {
  return api.patch("v1/users-suppliers/" + id);
}

export function generatePassword(id: number): AxiosPromise {
  return api.patch("v1/users-suppliers/" + id + "/password");
}

export default {
  getData,
  getDataById,
  postData,
  putData,
  deleteData,
  generatePassword,
  getSuppliers,
};
